(function() {
  function initVideoSlider(sectionId, openInModal) {
    const swiperContainer = document.getElementById('video-slider-' + sectionId);
    if (!swiperContainer) return;

    // Modal elements (only if modal mode is enabled)
    let modal = null;
    let modalBackdrop = null;
    let modalClose = null;
    let modalVideo = null;

    if (openInModal) {
      modal = document.getElementById('video-modal-' + sectionId);
      if (modal) {
        modalBackdrop = modal.querySelector('.video-slider-modal__backdrop');
        modalClose = modal.querySelector('.video-slider-modal__close');
        modalVideo = modal.querySelector('.video-slider-modal__video');
      }
    }

    // Get the real number of slides (excluding duplicates)
    const paginationEl = swiperContainer.querySelector('.video-slider-pagination');
    const realSlideCount = paginationEl ? parseInt(paginationEl.dataset.realCount, 10) : 3;

    // Create custom pagination bullets
    paginationEl.innerHTML = '';
    for (var i = 0; i < realSlideCount; i++) {
      var bullet = document.createElement('span');
      bullet.className = 'swiper-pagination-bullet';
      bullet.dataset.index = i;
      paginationEl.appendChild(bullet);
    }

    // Initialize Swiper without built-in pagination
    const swiper = new Swiper('#video-slider-' + sectionId, {
      spaceBetween: 0,
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        640: {  
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 3,
        }
      }
    });

    // Function to update active bullet
    function updatePagination() {
      var realIndex = swiper.realIndex % realSlideCount;
      var bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
      bullets.forEach(function(bullet, idx) {
        bullet.classList.toggle('swiper-pagination-bullet-active', idx === realIndex);
      });
    }

    // Update pagination on slide change
    swiper.on('slideChange', function() {
      updatePagination();
      // Stop all inline videos with fade out (only in non-modal mode)
      if (!openInModal) {
        swiperContainer.querySelectorAll('.video-slide__iframe').forEach(function(el) {
          el.classList.remove('is-visible');
          setTimeout(function() { el.innerHTML = ''; }, 400);
        });
        swiperContainer.querySelectorAll('.video-slide__cover').forEach(function(el) {
          el.classList.remove('is-hidden');
        });
      }
    });

    // Initial pagination state
    updatePagination();

    // Make bullets clickable
    paginationEl.addEventListener('click', function(e) {
      var bullet = e.target.closest('.swiper-pagination-bullet');
      if (bullet) {
        var index = parseInt(bullet.dataset.index, 10);
        swiper.slideToLoop(index);
      }
    });

    // Handle video play on click
    swiperContainer.addEventListener('click', function(e) {
      const coverBtn = e.target.closest('.video-slide__cover');
      if (!coverBtn) return;

      const container = coverBtn.closest('.video-slide__container');
      if (!container) return;

      const slide = container.closest('.swiper-slide');
      const iframeContainer = container.querySelector('.video-slide__iframe');

      // Get video data
      const youtubeId = container.dataset.youtubeId;
      const vimeoId = container.dataset.vimeoId;
      const videoUrl = container.dataset.videoUrl;
      const videoType = container.dataset.videoType || 'video/mp4';

      if (openInModal && modal) {
        // Modal mode - navigate to slide first if needed, then open modal
        if (slide && !slide.classList.contains('swiper-slide-active')) {
          const slideIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
          if (!isNaN(slideIndex)) {
            swiper.slideToLoop(slideIndex);
          }
        }
        openModalWithVideo(youtubeId, vimeoId, videoUrl, videoType);
      } else {
        // Inline mode
        if (!iframeContainer) return;

        // Navigate to clicked slide first (if not active)
        if (slide && !slide.classList.contains('swiper-slide-active')) {
          const slideIndex = parseInt(slide.dataset.swiperSlideIndex, 10);
          if (!isNaN(slideIndex)) {
            swiper.slideToLoop(slideIndex);
          }
          // Wait for slide transition and iframe clear (400ms) before playing video
          setTimeout(function() {
            playVideoInSlide(container, coverBtn, iframeContainer, youtubeId, vimeoId, videoUrl, videoType);
          }, 450);
        } else {
          playVideoInSlide(container, coverBtn, iframeContainer, youtubeId, vimeoId, videoUrl, videoType);
        }
      }
    });

    function getVideoHtml(youtubeId, vimeoId, videoUrl, videoType) {
      if (youtubeId) {
        return '<iframe src="https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&mute=0&playsinline=1" frameborder="0" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Video"></iframe>';
      } else if (vimeoId) {
        return '<iframe src="https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&muted=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen title="Video"></iframe>';
      } else if (videoUrl) {
        return '<video autoplay playsinline controls><source src="' + videoUrl + '" type="' + videoType + '"></video>';
      }
      return '';
    }

    function openModalWithVideo(youtubeId, vimeoId, videoUrl, videoType) {
      var videoHtml = getVideoHtml(youtubeId, vimeoId, videoUrl, videoType);
      if (!videoHtml) return;

      modalVideo.innerHTML = videoHtml;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      // Clear video after animation
      setTimeout(function() {
        modalVideo.innerHTML = '';
      }, 300);
    }

    // Modal event listeners
    if (openInModal && modal) {
      modalBackdrop.addEventListener('click', closeModal);
      modalClose.addEventListener('click', closeModal);
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }

    function playVideoInSlide(container, coverBtn, iframeContainer, youtubeId, vimeoId, videoUrl, videoType) {
      var videoHtml = getVideoHtml(youtubeId, vimeoId, videoUrl, videoType);

      if (videoHtml) {
        // Stop other videos first
        swiperContainer.querySelectorAll('.video-slide__iframe').forEach(function(el) {
          if (el !== iframeContainer) {
            el.classList.remove('is-visible');
            // Clear content after fade out
            setTimeout(function() { el.innerHTML = ''; }, 400);
          }
        });
        swiperContainer.querySelectorAll('.video-slide__cover').forEach(function(el) {
          if (el !== coverBtn) {
            el.classList.remove('is-hidden');
          }
        });

        // Play this video with fade transition
        iframeContainer.innerHTML = videoHtml;
        // Small delay to ensure content is loaded before fading in
        requestAnimationFrame(function() {
          iframeContainer.classList.add('is-visible');
          coverBtn.classList.add('is-hidden');
        });
      }
    }
  }

  window.initPolicyVideoSlider = initVideoSlider;
})();
